import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { FormCotacaoVeiculosModule } from 'src/app/_shared/form-cotacao-veiculos/form-cotacao-veiculos.module';
import { SliderBannerModule } from 'src/app/_shared/slider-banner/slider-banner.module';
import { CardsComponent } from './cards/cards.component';

@NgModule({
    declarations: [HomeComponent, CardsComponent],
    imports: [
        CommonModule,
        FormCotacaoVeiculosModule,
        SliderBannerModule
    ]
})
export class HomeModule { }
